<template>
    <div style="background-color: whitesmoke;">
        <b-modal id="modal-1"  hide-footer hide-header centered no-close-on-backdrop>
            <b-progress value="100" max="100" animated variant="secondary"></b-progress>
        </b-modal>
        
        <CCardBody class="tips_financial_table_modify">
            <h5>{{ $t('Single bets list') }}</h5>
            <CDataTable
                :items="items"
                :fields="fields"
                hover
                border
                striped
                outlined
               
            >
                <template v-slot:thead-top="props">
                    <tr class="first_tr">
                        <th colspan="18"></th>
                        <th colspan="5">{{ $t('P/L Points') }}</th>
                        <th colspan="3" class="leverage_color_weight">{{ $t('P/L Leverage stake') }}</th>
                        <th colspan="13" class="comp_color_weight">{{ $t('P/L compounding') }}</th>
                    </tr>
                    <tr class="first_tr">
                        
                        <th colspan="1" style="min-width: 150px;"></th>
                        <th colspan="1" style="min-width: 200px;"></th>
                        <th colspan="1" style="min-width: 170px;"></th> 
                        <th colspan="1" style="min-width: 300px;"></th>
                        <th colspan="1" style="min-width: 150px;"></th>
                        <th colspan="1"></th>
                        <th colspan="1"></th>
                        <th colspan="1" style="min-width: 120px;"></th>
                        <th colspan="1"></th>
                        <th colspan="1"></th>
                        <th colspan="1"></th>
                        <th colspan="1"></th>
                        <th colspan="2">{{ $t('entry odds') }}</th>
                        <th colspan="2">{{ $t('cashout odds') }}</th>
                        <th colspan="1"></th>
                        <!-- <th colspan="1"></th>  -->
                        <th colspan="1" style="min-width: 130px;"></th>

                        

                        <th colspan="1">{{ $t('Back') }}</th>
                        <th colspan="4">{{ $t('Lay') }}</th>
                        <th colspan="1" style="background-color: #FFF2CC">{{ $t('Back') }}</th>
                        <th colspan="2" style="background-color: #FFF2CC">{{ $t('Lay') }}</th>

                        <th colspan="4" class="comp_color_light">{{ $t('Back') }}</th>
                        <th colspan="5" class="comp_color_light">{{ $t('Lay (Payout)') }}</th>
                        <th colspan="4" class="comp_color_light">{{ $t('Lay (liability)') }}</th>                        
                    </tr>
                </template>

                <template #outcome="{item, index}">
                    <!-- <td :class="{'white-color': true, 'green-background' : item['outcome'] == 'V', 'red-background' : item['outcome'] == 'F'}">{{item.outcome}}
                    </td> -->
                    <td>
                        <span :class="{'outcome-col': true, 'green-background' : item['outcome'] == 'V', 'red-background' : item['outcome'] == 'F'}">{{item.outcome}}</span>
                    </td>
                </template>

                <template #points_back="{item, index}">
                    <td  :class="{'cell_left_solid': true, 'positive-mark' : item.points_back > 0, 'negative-mark' : item.points_back < 0}">
                        {{ String(item.points_back).replace(".", ",") }}
                    </td>
                </template>
                <template #points_payout="{item, index}">
                    <td  :class="{'positive-mark' : item.points_payout > 0, 'negative-mark' : item.points_payout < 0}">
                        {{ String(item.points_payout).replace(".", ",") }}
                    </td>
                </template>
                <template #points_liab_stake="{item, index}">
                    <td  :class="{'positive-mark' : item.points_liab_stake > 0, 'negative-mark' : item.points_liab_stake < 0}">
                        {{ String(item.points_liab_stake).replace(".", ",") }}
                    </td>
                </template>
                <template #points_liab_risk="{item, index}">
                    <td  :class="{'positive-mark' : item.points_liab_risk > 0, 'negative-mark' : item.points_liab_risk < 0}">
                        {{ String(item.points_liab_risk).replace(".", ",") }}
                    </td>
                </template>
                <template #points_liability="{item, index}">
                    <td  :class="{'positive-mark' : item.points_liability > 0, 'negative-mark' : item.points_liability < 0}">
                        {{ String(item.points_liability).replace(".", ",") }}
                    </td>
                </template>
                <template #stake_back="{item, index}">
                    <td :class="{'cell_left_solid': true, 'positive-mark' : item.stake_back > 0, 'negative-mark' : item.stake_back < 0}">
                        {{ String(item.stake_back).replace(".", ",") }}
                    </td>
                </template>
                <template #stake_payout="{item, index}">
                    <td  :class="{'positive-mark' : item.stake_payout > 0, 'negative-mark' : item.stake_payout < 0}">
                        {{ String(item.stake_payout).replace(".", ",") }}
                    </td>
                </template>
                <template #stake_liability="{item, index}">
                    <td  :class="{'positive-mark' : item.stake_liability > 0, 'negative-mark' : item.stake_liability < 0}">
                        {{ String(item.stake_liability).replace(".", ",") }}
                    </td>
                </template>
                <template #comp_back="{item, index}">
                    <td  :class="{'cell_left_solid': true, 'positive-mark' : item.comp_back > 0, 'negative-mark' : item.comp_back < 0}">
                        {{ String(item.comp_back).replace(".", ",") }}
                    </td>
                </template>
                <template #comp_back_cur_bank="{item, index}">
                    <td  :class="{'positive-mark' : item.comp_back_cur_bank > 0, 'negative-mark' : item.comp_back_cur_bank < 0}">
                        {{ String(item.comp_back_cur_bank).replace(".", ",") }}
                    </td>
                </template>
                <template #comp_back_stake_back="{item, index}">
                    <td  :class="{'positive-mark' : item.comp_back_stake_back > 0, 'negative-mark' : item.comp_back_stake_back < 0}">
                        {{ String(item.comp_back_stake_back).replace(".", ",") }}
                    </td>
                </template>
                <template #comp_back_draw_down="{item, index}">
                    <td  :class="{'positive-mark' : item.comp_back_draw_down > 0, 'negative-mark' : item.comp_back_draw_down < 0}">
                        {{ String(item.comp_back_draw_down).replace(".", ",") }}
                    </td>
                </template>
                <template #comp_payout="{item, index}">
                    <td  :class="{'positive-mark' : item.comp_payout > 0, 'negative-mark' : item.comp_payout < 0}">
                        {{ String(item.comp_payout).replace(".", ",") }}
                    </td>
                </template>
                <template #comp_pay_cur_bank="{item, index}">
                    <td  :class="{'positive-mark' : item.comp_pay_cur_bank > 0, 'negative-mark' : item.comp_pay_cur_bank < 0}">
                        {{ String(item.comp_pay_cur_bank).replace(".", ",") }}
                    </td>
                </template>
                <template #comp_pay_stake_lay="{item, index}">
                    <td  :class="{'positive-mark' : item.comp_pay_stake_lay > 0, 'negative-mark' : item.comp_pay_stake_lay < 0}">
                        {{ String(item.comp_pay_stake_lay).replace(".", ",") }}
                    </td>
                </template>
                <template #comp_pay_risk="{item, index}">
                    <td  :class="{'positive-mark' : item.comp_pay_risk > 0, 'negative-mark' : item.comp_pay_risk < 0}">
                        {{ String(item.comp_pay_risk).replace(".", ",") }}
                    </td>
                </template>
                <template #comp_pay_draw_down="{item, index}">
                    <td  :class="{'positive-mark' : item.comp_pay_draw_down > 0, 'negative-mark' : item.comp_pay_draw_down < 0}">
                        {{ String(item.comp_pay_draw_down).replace(".", ",") }}
                    </td>
                </template>
                <template #comp_liability="{item, index}">
                    <td  :class="{'positive-mark' : item.comp_liability > 0, 'negative-mark' : item.comp_liability < 0}">
                        {{ String(item.comp_liability).replace(".", ",") }}
                    </td>
                </template>
                <template #comp_lia_cur_bank="{item, index}">
                    <td  :class="{'positive-mark' : item.comp_lia_cur_bank > 0, 'negative-mark' : item.comp_lia_cur_bank < 0}">
                        {{ String(item.comp_lia_cur_bank).replace(".", ",") }}
                    </td>
                </template>
                <template #comp_lia_stake_lay="{item, index}">
                    <td  :class="{'positive-mark' : item.comp_lia_stake_lay > 0, 'negative-mark' : item.comp_lia_stake_lay < 0}">
                        {{ String(item.comp_lia_stake_lay).replace(".", ",") }}
                    </td>
                </template>
                <template #comp_lia_draw_down="{item, index}">
                    <td  :class="{'cell_right_solid': true, 'positive-mark' : item.comp_lia_draw_down > 0, 'negative-mark' : item.comp_lia_draw_down < 0}">
                        {{ String(item.comp_lia_draw_down).replace(".", ",") }}
                    </td>
                </template>

            </CDataTable>
        </CCardBody>
    </div>
</template>

<script>
import { Plotly } from 'vue-plotly'
import swal from "sweetalert2";
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'FinancialTable',
    components: {
        Plotly,
       
    },
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            fields: [
                { key: 'Country', label: this.$t('Country')},
                { key: 'League', label: this.$t('League')},
                { key: 'Post Date', label: this.$t('Post Date')},
                // { key: 'Post Time', label: this.$t('Post Time')},
                { key: 'Event', label: this.$t('Event')},
                { key: 'Prediction', label: this.$t('Prediction')},
                { key: 'Bet Side', label: this.$t('Bet Side')},
                { key: 'tipORcover', label: this.$t('tip/cover')},
                { key: 'Entry min', label: this.$t('Entry min')},
                { key: 'Cash out', label: this.$t('Cash out')},
                { key: 'Bet 365 Entry', label: this.$t('Bet 365 Entry')},
                { key: 'Bet 365 CO Odds', label: this.$t('Bet 365 CO Odds')},
                { key: 'stake', label: this.$t('stake')},
                { key: 'entry_back_odd', label: this.$t('Back Odd')},
                { key: 'entry_lay_odd', label: this.$t('Lay Odd')},
                { key: 'cashout_back_odd', label: this.$t('Back Odd')},
                { key: 'cashout_lay_odd', label: this.$t('Lay Odd')},
                { key: 'outcome', label: this.$t('Outcome')},
                // { key: 'Lay Risk', label: this.$t('Lay Risk')},
                { key: 'result', label: this.$t('Score')},

                { key: 'points_back', label: this.$t('Back') + " " + this.$t('Profit')},
                { key: 'points_payout', label: this.$t('Payout') + " " + this.$t('Profit')},
                { key: 'points_liability', label: this.$t('Liability') + " " + this.$t('Profit')},
                { key: 'points_liab_stake', label: this.$t('liab stake')},
                { key: 'points_liab_risk', label: this.$t('liab risk')},
                

                { key: 'stake_back', label: this.$t('Back') + " " + this.$t('Profit'), _classes: "leverage_color_light"},
                { key: 'stake_payout', label: this.$t('Payout') + " " + this.$t('Profit'), _classes: "leverage_color_light"},
                { key: 'stake_liability', label: this.$t('Liability') + " " + this.$t('Profit'), _classes: "leverage_color_light"},

                { key: 'comp_back', label: this.$t('Back') + " " + this.$t('Profit'), _classes: "comp_color_light"},
                { key: 'comp_back_cur_bank', label: this.$t('current Bank'), _classes: "comp_color_light"},
                { key: 'comp_back_stake_back', label: this.$t('stake Back'), _classes: "comp_color_light"},
                { key: 'comp_back_draw_down', label: this.$t('draw Down'), _classes: "comp_color_light"},

                { key: 'comp_payout', label: this.$t('Payout') + " " + this.$t('Profit'), _classes: "comp_color_light"},
                { key: 'comp_pay_cur_bank', label: this.$t('current Bank'), _classes: "comp_color_light"},
                { key: 'comp_pay_stake_lay', label: this.$t('stake Lay'), _classes: "comp_color_light"},
                { key: 'comp_pay_risk', label: this.$t('lay risk'), _classes: "comp_color_light"},
                { key: 'comp_pay_draw_down', label: this.$t('draw Down'), _classes: "comp_color_light"},

                { key: 'comp_liability', label: this.$t('Liability') + " " + this.$t('Profit'), _classes: "comp_color_light"},
                { key: 'comp_lia_cur_bank', label: this.$t('current Bank'), _classes: "comp_color_light"},
                { key: 'comp_lia_stake_lay', label: this.$t('stake Lay'), _classes: "comp_color_light"},
                { key: 'comp_lia_draw_down', label: this.$t('draw Down'), _classes: "comp_color_light"},
            ],
            loading: true
        }
    },
    created() {
        console.log('==============  created function')
    },
    mounted: function (){
        this.$nextTick(function () {
            console.log('==============  mounted function')
            

        })
    },
    methods: {
        ...mapActions([
                'getStatsByUserId'
            ]),
        
        showModal() {
            // this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')

            console.log('show modal')
            this.$bvModal.show('modal-1')
            console.log('show modal close')
        },
        hideModal() {
            this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
        },
    }
}
</script>
<style scoped>
    .positive-mark {
        color: green
    }
    .negative-mark {
        color: red
    }
    .leverage_color_weight {
        background-color: #FFC000;
    }
    .leverage_color_light {
        background-color: #FFF2CC !important;
    }
    .comp_color_weight {
        background-color: #9BC2E6;
    }
    .comp_color_light {
        background-color: #DDEBF7 !important;
    }
    .cell_left_solid {
        /*border-left: solid !important;
        border-left-color: black !important;*/
        border-left: groove;
    }
    .cell_right_solid {
        /*border-right: solid !important;
        border-right-color: black !important;*/
        border-right: groove;
    }

</style>
<style>


.tips_financial_table_modify .table-responsive{
    margin-top: 20px !important;
    max-height: 80vh !important;
}

thead {
    padding: 3px;
    position: sticky;
    top: 0;
    z-index: 1;
    /* width: 25vw; */
    background: white;
}
.first_tr{
    background-color: #bae1aa ;
}
.first_tr + tr{
    background-color: #dff0d8;
}
.leverage_color_light {
    background-color: #FFF2CC !important;
}
.comp_color_weight {
    background-color: #9BC2E6;
}
.comp_color_light {
    background-color: #DDEBF7 !important;
}
.cell_left_solid {
    /*border-left: solid !important;
    border-left-color: black !important;*/
    border-left: groove;
}
.cell_right_solid {
    /*border-right: solid !important;
    border-right-color: black !important;*/
    border-right: groove;
}
.outcome-col {
    color:  white;
    min-width: 35px;
    display: inline-block;
    border-radius: 5px;
}
.green-background {
    background-color:  green;
}
.red-background {
    background-color:  red;
}
</style>